<template>
	<div id="app">
		<Header></Header>
		<router-view></router-view>
		<Footer></Footer>
	</div>
</template>

<script>
import Header from './components/Header.vue';
import Footer from './components/Footer.vue';
export default {
	name: 'app',
	components: {
		Header,
		Footer
	}
};
</script>

<style lang="less">
* {
	margin: 0;
	padding: 0;
	transition: 0.2s linear;
}

// 在填充数据之前隐藏
[v-cloak] {
	display: none;
}

.content {
	max-width: 1244px;
	margin: 0 auto;
}

.title {
	text-align: center;
	position: relative;
	font-size: 38px;
	font-weight: bold;
	color: #262626;
	line-height: 48px;
	padding-bottom: 44px;
	transition: all 400ms ease-in-out;
}

.title:hover {
	text-shadow: 1px 1px 0 #262626bd;
}

.title:hover p {
	transform: translate(-9px, -9px);
}

.title::after {
	content: '';
	position: absolute;
	width: 108px;
	height: 3px;
	left: 50%;
	margin-left: -54px;
	background: #ff5300;
	border-radius: 1px;
	bottom: 3px;
}

.intervention {
	background: url('~@/assets/bg_guanli_jiejue_fangan.png') no-repeat center;
	background-size: 100% 100%;
	width: 100%;
	overflow: hidden;
	padding: 0 !important;

	.content {
		position: relative;
		padding: 147px 0 219px;

		.bg {
			width: 770px;
			position: absolute;
			right: 0;
			bottom: 0;
		}
	}
}

.cloudPlatform {
	background: url('~@/assets/bg_fuwu_yunpingtai.png') no-repeat center;
	background-size: 100% 100%;
	width: 100%;
	overflow: hidden;
	padding: 0 !important;

	.content {
		position: relative;
		padding: 131px 0 198px;
		overflow: hidden;

		.bg {
			width: 601px;
			position: absolute;
			left: 0;
			bottom: 98px;
		}
	}

	.textarea {
		float: right;

		h5 {
			color: #262626;
		}

		p {
			color: #8e8e8e;
		}
	}
}

.textarea {
	width: 538px;

	span {
		font-size: 20px;
		font-weight: 400;
		color: #ff5300;
		line-height: 36px;
	}

	h5 {
		font-size: 40px;
		font-weight: bold;
		color: #ffffff;
		line-height: 60px;
		margin: 32px 0 82px;
	}

	p {
		font-size: 16px;
		font-weight: 400;
		color: #ffffff;
		line-height: 36px;
	}
}

.solution {
	.banner {
		position: relative;
		overflow: hidden;

		img {
			width: 100%;
			display: block;
		}

		.small {
			display: none;
		}

		div {
			width: 100%;
			position: absolute;
			left: 50%;
			top: 50%;
			transform: translate(-50%, -50%);
			text-align: center;
		}

		h5 {
			font-size: 72px;
			color: #142448;
			line-height: 120px;
			animation: lefteaseinAnimate 1.5s ease 1;
		}

		p {
			font-size: 36px;
			color: #346592;
			animation: righteaseinAnimate 1.5s ease 1;
		}

		em {
			display: block;
			font-style: inherit;
			font-size: 36px;
			color: #346592;
			animation: lefteaseinAnimate 1.5s ease 1;
		}

		@keyframes lefteaseinAnimate {
			0% {
				transform: translateX(-2000px);
				opacity: 0;
			}

			100% {
				transform: translateX(0px);
				opacity: 1;
			}
		}

		@keyframes righteaseinAnimate {
			0% {
				transform: translateX(2000px);
				opacity: 0;
			}

			100% {
				transform: translateX(0px);
				opacity: 1;
			}
		}
	}
}

@media (max-width: 768px) {
	.solution .banner {
		h5 {
			font-size: 48px;
			line-height: inherit;
		}

		p {
			color: #275d90;
			font-size: 28px;
			margin-top: 30px;
		}

		img {
			display: none;
		}

		.small {
			display: block;
		}
	}

	.cloudPlatform {
		width: 100% !important;
		background: url('~@/assets/bg_chanpin_zhongxin_yunfuwu_pingtai_small.png') no-repeat center;
		background-size: 100% 100%;
		padding: 0 !important;

		.content {
			display: block;
			padding: 70px 0 0;

			.bg {
				width: 86%;
				display: block;
				margin: 56px auto 73px;
				position: initial;
			}

			.bg:first-child {
				display: none;
			}

			.bg:last-child {
				display: block;
			}
		}

		img {
			display: block;
			margin: 44px auto 77px;
		}

		.textarea {
			width: 92%;
			float: inherit;
			margin: 0 auto;
		}
	}

	.intervention {
		width: 100% !important;
		background: url('~@/assets/bg_guanli_jiejue_fangan_small.png') no-repeat center;
		background-size: 100% 100%;
		width: 100%;
		overflow: hidden;
		padding: 0 !important;

		.content {
			padding: 70px 0 0;

			.bg {
				width: 86%;
				display: block;
				margin: 0 auto 32px;
				position: inherit;
			}
		}

		.textarea {
			width: 92%;
			margin: 0 auto 103px;

			h5 {
				margin: 27px 0 74px;
			}

			p {
				color: rgba(255, 255, 255, 0.5);
				text-align: justify;
			}
		}
	}
}
</style>
